const schoolPlaceholderDescription = {
    methods: {
        getSchoolPlaceholderDescriptionText(
            schoolName,
            schoolType,
            schoolCity
        ) {
            const prefix = this.getSchoolTypePrefix(schoolType) + " "
            const prefixUpperCase =
                prefix.charAt(0).toUpperCase() + prefix.slice(1)
            let city = schoolName
                .toLowerCase()
                .includes(schoolCity?.toLowerCase())
                ? ""
                : " in " + schoolCity
            let placeholderText =
                prefixUpperCase +
                schoolName +
                city +
                " spielt Berufsorientierung eine große Rolle. Berufe in der Praxis auszuprobieren, eine Vielfalt an berufsvorbereitenden Maßnahmen, sowie eine enge Vernetzung mit den Unternehmen und weiteren Bildungseinrichtungen vor Ort sind uns sehr wichtig. So begleiten wir unsere SchülerInnen intensiv in Richtung Wunschberuf. Wir freuen uns auf eine gewinnbringende Zusammenarbeit mit allen zukünftigen ArbeitgeberInnen und wünschen unseren SchülerInnen und AbsolventInnen viel Erfolg und Spaß beim Praktikum oder einer Ausbildung."

            return placeholderText
        },
        getSchoolTypePrefix(schoolType, auf = false) {
            let prefix = ""
            switch (schoolType) {
                case "Abendgymnasium":
                case "Gymnasium":
                    prefix = auf ? "auf dem" : "am"
                    break
                case "Abendrealschule":
                case "Ausländische Schule":
                case "Berufsfachschule f. Fremdsprachenberufe":
                case "Berufsfachschule des Gesundheitswesens":
                case "Berufsfachs. f. Hauswirtschaft u. Sozialberufe":
                case "Berufsfachschule f. techn. Assistenzberufe":
                case "Berufsoberschule":
                case "Berufsschule":
                case "Berufsschule zur sonderpädagog. Förderung":
                case "Berufsfachschule f. Musik":
                case "Fachakademie für Landwirtschaft":
                case "Fachakademie":
                case "Fachoberschule":
                case "Freie Waldorfschule":
                case "Gewerbliche Berufsfachschule":
                case "Gewerbliche Fachschule":
                case "Grund- u. Mittelschule":
                case "Mittelschule":
                case "Hauswirtschaftliche Fachschule":
                case "Kaufmännische Berufsfachschule":
                case "Kaufmännische Fachschule":
                case "Landwirtschaftliche Fachschule":
                case "Realschule zur sonderpädagog. Förderung":
                case "Realschule":
                case "Schule besonderer Art":
                case "Sonstige Berufsfachschule":
                case "Sonstige Fachschule":
                case "Volksschule zur sonderpädagog. Förderung":
                case "Wirtschaftsschule":
                    prefix = auf ? "an der" : "an der"
                    break
                case "Kolleg":
                    prefix = auf ? "auf dem" : "am"
            }
            return prefix
        },
    },
}
export default schoolPlaceholderDescription
